import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";
import { accountIdSchema } from "./accountSchema";

export const deviceIdPrefix = "dev_";
export type DeviceId = ID<typeof deviceIdPrefix>;
export const generateDeviceId = makeIdGenerator(deviceIdPrefix);
export const deviceIdSchema = getIdSchema(deviceIdPrefix, "DeviceId");

export const deviceSchema = z
  .object({
    id: deviceIdSchema,
    accountId: accountIdSchema,
    name: z.string(),
    hardwareId: z.string(),
    retiredAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
    lastTransmission: z.coerce.date().nullable(),
    batteryV: z.number().nullable(),
    hasBeenAllocated: z.boolean(),
  })
  .meta({ id: "Device" });

export type Device = z.infer<typeof deviceSchema>;

export const putDeviceSchema = z
  .object({
    name: z.string().min(1),
    retiredAt: z.coerce.date().nullable(),
  })
  .meta({ id: "DeviceUpdate" });

export type PutDevice = z.infer<typeof putDeviceSchema>;
